import React from 'react';
import { useAnalytics } from '../../../core/Analytics/AnalyticsProvider';
import { PageView, UserInteractionEvent } from '../../../models/analytics';
import { AccountItem } from './AccountItem';

export type ListAccount = {
  id: string;
  accountNumber: string;
  name: string;
  holderName: string;
  iban: string;
  balance?: string;
};

type AccountListItemProps = {
  account: ListAccount;
  highlighted: boolean;
  onClick: (accountId: string) => void;
  allowSelectMultipleAccounts: boolean;
  balance?: string;
};

export const AccountListItem: React.FC<AccountListItemProps> = ({
  account,
  highlighted,
  onClick,
  allowSelectMultipleAccounts,
  balance = undefined,
}) => {
  const { tinklinkAnalytics } = useAnalytics();
  const { id, accountNumber, name } = account;

  return (
    <AccountItem
      selected={highlighted}
      onChange={() => {
        tinklinkAnalytics.sendInteractionEvent({
          action: `${PageView.ACCOUNT_SELECTION_SCREEN}/${UserInteractionEvent.LIST_ITEM}`,
          view: PageView.ACCOUNT_SELECTION_SCREEN,
          label: 'ACCOUNT_ITEM',
        });

        onClick(account.id);
      }}
      key={id}
      id={id}
      name={name}
      balance={balance}
      accountNumber={accountNumber}
      allowSelectMultipleAccounts={allowSelectMultipleAccounts}
    />
  );
};
